.tagInput {
  min-width: 80px;
  background: transparent;
  outline: none;
}

.editInput {
  min-width: 80px;
  max-width: 220px;
  font-size: 0.875em;
  background: transparent;
  outline: none;
}

.editInput:focus {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 0.15rem rgba(var(--bs-primary-rgb), 0.25);
}

.chip {
  font-size: 0.875em;
}

.chipClickable {
  cursor: pointer;
}

.chipDisabled {
  cursor: default;
}

.dropdownItem {
  cursor: pointer;
}

.dropdownItemActive {
  background-color: var(--bs-primary);
  color: var(--bs-primary-text);
}

.dropdownItemCreate {
  font-style: italic;
}

.dropdownCheckbox {
  cursor: pointer;
  pointer-events: none;
}
